module.exports = __webpack_public_path__ + "static/rad1-d5c95cbffa3409f345da77fb88e317c4.jpg";